import { render, staticRenderFns } from "./obuFiled.vue?vue&type=template&id=03e33922&scoped=true&"
import script from "./obuFiled.vue?vue&type=script&lang=ts&"
export * from "./obuFiled.vue?vue&type=script&lang=ts&"
import style0 from "./obuFiled.vue?vue&type=style&index=0&id=03e33922&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e33922",
  null
  
)

export default component.exports